export default {
    type: 'rating',
    config: {
        fixedWidth: 48
    },
    default: {
        label: 'You'
    },
    unique: [],
    sort: 'rating.user',
    lang: {
        name: 'User Rating',
        views: ['list', 'sheet', 'grid'],
        category: ['User', 'Ratings'],
        description: 'User rating given to the game.',
    },
    visibility: function() {

        return this.isUser || this.isBuddies || (this.isGroup && this.isMember)

    },
    filters: ['rating']
}